<div class="user-selection-new-contract">
  <div class="user-selection-new-contract__header">
    <h2 class="user-selection-new-contract__title">{{ 'NEW_CONTRACTS.USER.TITLE' | i18nextEager }}</h2>
  </div>
  <section>
    <h2>{{ 'NEW_CONTRACTS.USER.SELECTION_TITLE' | i18nextEager }}</h2>
    <form [formGroup]="userDataForm">
      <mat-radio-group
        aria-labelledby=""
        class="crm_options"
        formControlName="crm_option"
        (change)="onChangeCRMOption($event)"
      >
        <mat-radio-button value="0">
          <span class="bold">{{ user.fullName }}</span> ({{ role | i18nextEager }})
        </mat-radio-button>
        <mat-radio-button value="1">
          <span class="bold">{{ 'NEW_CONTRACTS.TEAM_ASIGNED' | i18nextEager }}</span>
        </mat-radio-button>
      </mat-radio-group>
      <div *ngIf="userDataForm.controls.crm_option.value == 1" class="search">
        <mat-form-field appearance="outline" class="search">
          <input matInput formControlName="search" (ngModelChange)="onChangeSearch($event)" maxlength="50" />
          <button type="submit" (click)="search(false)" class="suffix-icon" *ngIf="reseted; else elseBlock">
            <img src="/assets/icons/search.svg" alt="" />
          </button>
          <ng-template #elseBlock>
            <button type="reset" (click)="reset()" class="suffix-icon">
              <img src="/assets/icons/close.svg" alt="" />
            </button>
          </ng-template>
        </mat-form-field>
      </div>
      <div class="results" *ngIf="userDataForm.get('crm_option').value == 1 && results">
        <div class="bold results__count">{{ results.totalCount }} {{ 'HOME.SEARCH.RESULTS' | i18nextEager }}</div>
        <div class="results__data" *ngIf="results.values?.length > 0">
          <mat-radio-group
            aria-labelledby=""
            formControlName="crm_comm_option"
            (change)="onChangeCRMCommOption($event)"
          >
            <div class="results__data__item" *ngFor="let item of results.values | slice: 0:showItems">
              <div><mat-radio-button [value]="item.contactoCRM"> </mat-radio-button></div>
              <div>{{ item.dni }}</div>
              <div>{{ item.nombreCompleto }}</div>
            </div>
          </mat-radio-group>
        </div>
        <div *ngIf="showItems < results.totalCount" class="more_results">
          <span (click)="showMoreResults()">{{ 'HOME.SEARCH.MORE_RESULTS' | i18nextEager }}</span>
        </div>
      </div>
    </form>
  </section>
</div>
